import AsyncStorage from '@react-native-async-storage/async-storage';

/**
 * Shared API helpers for the rules engine.
 * Centralises auth-header and base-url retrieval so every caller
 * uses the same AsyncStorage keys and Bearer format.
 */

export async function getAuthHeaders() {
  const access_token = await AsyncStorage.getItem('access_token');
  return { Authorization: `Bearer ${access_token}` };
}

export async function getBaseUrl() {
  return await AsyncStorage.getItem('url');
}
